import { render, staticRenderFns } from "./skin.vue?vue&type=template&id=2b0b0b1c&scoped=true"
import script from "./skin.vue?vue&type=script&lang=js"
export * from "./skin.vue?vue&type=script&lang=js"
import style0 from "./skin.vue?vue&type=style&index=0&id=2b0b0b1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@5.2.7_vue-template-compiler@2.6.14_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0b0b1c",
  null
  
)

export default component.exports